module.exports = __webpack_public_path__ + "static/media/comboTipoRegistro.2c420b3e.png";